module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.f6637f5e.xml";